import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IQueryParam, IFilter, ILogHttp, ILogGenerico } from 'modelos/src';
import { Subscription } from 'rxjs';
import { IColumnas } from '../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../auxiliares/tabla/filtro/filtro.component';

import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { LoginService } from '../../../login/login.service';
import { MatDialog } from '@angular/material/dialog';
import { DetallesLogGenericoComponent } from '../detalles-log-generico/detalles-log-generico.component';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import { TablaComponent } from '../../../../auxiliares/tabla/tabla.component';
import { fechaLogHtml } from '../fecha-log';

@Component({
  selector: 'app-listadologs-mensajes-test',
  templateUrl: './listado-logs-mensajes-test.component.html',
  styleUrl: './listado-logs-mensajes-test.component.scss',
  standalone: true,
  imports: [TablaComponent, DetallesLogGenericoComponent],
})
export class ListadoLogsMensajesTestComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  matDialog = inject(MatDialog);

  public loading = false;
  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoLogsMensajesTestComponent';
  public logHttp?: ILogGenerico[];
  public totalCount = 0;
  public columnas?: IColumnas<ILogGenerico>[];
  public logGenericoSeleccionado?: ILogGenerico;
  // Subs
  public logGenerico$?: Subscription;

  // FILTROS
  // Buscar
  public search: IRegExpSearch = {
    fields: ['tipoEntidad', 'identificacion', 'valores.mensaje'],
  };
  // Fecha de creación
  private fechaCreacion: IFiltroTabla = {
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Buscar por fecha',
    tipo: 'dateRange',
  };
  //
  public filtros: IFiltroTabla[] = [this.fechaCreacion];
  // Query
  public filter: Partial<IFilter<ILogGenerico>> = {};
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  // Listars
  public async listar(): Promise<void> {
    this.logGenerico$?.unsubscribe();
    this.logGenerico$ = this.lista2
      .logsGenericos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.logHttp = data.datos;
      });
  }

  // Acciones

  public verDetalles(dato: ILogGenerico): void {
    this.logGenericoSeleccionado = dato;
  }

  public cerrarDetalles(): void {
    this.logGenericoSeleccionado = undefined;
  }
  /////////////////////////////////////////////////////////////
  // Tabla

  private escaparHtml(valor: string): string {
    return valor
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private setColumnas() {
    const columnas: IColumnas<ILogGenerico>[] = [
      // Fecha (con segundos: en los logs importan)
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          html: (dato) => fechaLogHtml(dato.fechaCreacion),
          noData: 'Sin fecha',
        },
      },

      // Tipo de entidad
      {
        header: {
          label: 'Tipo de entidad',
        },
        row: {
          field: 'tipoEntidad',
          noData: 'Sin tipo de entidad',
        },
      },

      // Protocolo
      {
        header: {
          label: 'Protocolo',
        },
        row: {
          parse: (dato) => dato?.valores?.protocolo,
          noData: 'Sin protocolo',
        },
      },

      // Origen
      {
        header: {
          label: 'Origen',
        },
        row: {
          parse: (dato) => dato?.valores?.origen,
          noData: 'Sin origen',
        },
      },

      // Puerto
      {
        header: {
          label: 'Puerto',
        },
        row: {
          parse: (dato) => dato?.valores?.puerto,
          noData: 'Sin puerto',
        },
      },

      // Mensaje
      {
        header: {
          label: 'Mensaje',
        },
        row: {
          html: (dato) => {
            const mensaje = dato?.valores?.mensaje;
            if (!mensaje) return '';
            // Truncar mensaje si es muy largo (completo en el tooltip y en el
            // detalle)
            const truncado =
              mensaje.length > 50 ? mensaje.substring(0, 50) + '…' : mensaje;
            // El `html` de una columna se pinta con `bypassSecurityTrustHtml`:
            // Angular NO lo sanitiza, y esto es lo que mandó quien sea que
            // apuntó al puerto de test. Va escapado.
            return `<span class="tabla-codigo">${this.escaparHtml(truncado)}</span>`;
          },
          tooltip: (dato) => dato?.valores?.mensaje,
          noData: 'Sin mensaje',
        },
      },
    ];

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            icon: 'visibility',
            tooltip: 'Ver detalle',
            click: (dato) => this.verDetalles(dato),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.logGenerico$?.unsubscribe();
  }
}
